import Api from './Api'

export default {
    get_datas(){
        return Api().get(`datas/`);
    },
    update_dtCampanha(data){
        return Api().patch('datas/update-campanha', {data});
    },
    update_dtMaterial(data){
        return Api().patch('datas/update-material', {data});
    },
    update_dtPos(data){
        return Api().patch('datas/update-pos', {data});
    },
    get_evento_limite(){
        return Api().get('datas/evento-limite');
    },
    get_evento_total_limite(){
        return Api().get('datas/evento-total-limite');
    },
}